import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteUser2FANumber: builder.mutation<
      void,
      { accountId: string; accountUserId: string }
    >({
      query: ({ accountId, accountUserId }) => ({
        url: `/v4/accounts/${accountId}/users/${accountUserId}/2fa-phoneNumber`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useDeleteUser2FANumberMutation } = apiSlice;
